import { __assign } from '../node_modules/tslib/tslib.es6.mjs.js';
import React from 'react';
import { Icon } from '@chakra-ui/react';

var CheckedIconWithBorder = function (props) { return (React.createElement(Icon, __assign({ width: "25px", height: "25px", viewBox: "0 0 27 26", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13.5 25.5C20.4036 25.5 26 19.9036 26 13C26 6.09644 20.4036 0.5 13.5 0.5C6.59644 0.5 1 6.09644 1 13C1 19.9036 6.59644 25.5 13.5 25.5Z", fill: "#559D72", stroke: "#9EA7B6", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M19.4583 10L11.8151 17.2917L8 13.6458", fill: "#559D72" }),
    React.createElement("path", { d: "M19.4583 10L11.8151 17.2917L8 13.6458", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))); };

export { CheckedIconWithBorder as default };
//# sourceMappingURL=CheckedIconWithBorder.js.map
